const ExtraComputeString = ({ type, value }) => {
  if (type === "FIX_DAYS") return `${value} days.`;
  if (type === "QTY_PER_DAY") return `${value} / day.`;

  return "Invalid type.";
};

export default ExtraComputeString;
